import React from "react";

import type { Fn, IgnoreAny } from "./types";

const toString = Object.prototype.toString;

export function isFunction<T extends Fn>(val: IgnoreAny): val is T {
  return typeof val === "function";
}
export const isDef = <T = IgnoreAny>(val?: T): val is T => typeof val !== "undefined";
export function isUndef(value: unknown): value is undefined {
  return typeof value === "undefined";
}
export const isBoolean = (val: IgnoreAny): val is boolean => typeof val === "boolean";

export const isNumber = (val: IgnoreAny): val is number => typeof val === "number";
export function isString(val: unknown): val is string {
  return typeof val === "string";
}
export function isObject(val: IgnoreAny): val is object {
  return toString.call(val) === "[object Object]";
}

export const isDev = window.location.hostname.includes("localhost");

export const isBrowser = typeof window !== "undefined";
export const isNavigator = typeof navigator !== "undefined";

export function noop() {
  // do nothing
}

export const isIOS =
  /* #__PURE__ */ isBrowser &&
  window?.navigator?.userAgent &&
  /iP(?:ad|hone|od)/.test(window.navigator.userAgent);

export const isReactLegacy = !React.useId;
